import { render } from "./ProblemCard.vue?vue&type=template&id=04f553b7"
import script from "./ProblemCard.vue?vue&type=script&lang=js"
export * from "./ProblemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__